'use client';
import { useState } from 'react';
import { TypeMediaCollectionProduct } from '@/core/generated-types';

export interface MediaCollectionNavigationPosition {
  partId: string;
  chapterId: string;
}

function useMediaCollectionNavigation(
  mediaCollectionProduct: TypeMediaCollectionProduct,
) {
  const { parts } = mediaCollectionProduct.fields;

  const [navigationPosition, setNavigationPosition] = useState({
    partId: '',
    chapterId: '',
  } as MediaCollectionNavigationPosition);

  const activePart = parts.find(
    (part) => part.sys.id === navigationPosition.partId,
  );

  const activeChapter = activePart?.fields?.chapters.find(
    (chapter) => chapter.sys.id === navigationPosition.chapterId,
  );
  const activePartIndex = activePart ? parts.indexOf(activePart) : 0;

  function navigateToChapter(chapterId: string) {
    setNavigationPosition((prevState) => ({
      ...prevState,
      chapterId,
    }));
  }

  function navigateToPosition(partId: string, chapterId?: string) {
    if (chapterId) {
      setNavigationPosition((prevState) => ({
        ...prevState,
        chapterId,
        partId,
      }));
    } else {
      setNavigationPosition((prevState) => ({
        ...prevState,
        partId,
      }));
    }
  }

  return {
    navigationPosition,
    activeChapter,
    activePart,
    activePartIndex,
    navigateToPosition,
    navigateToChapter,
  };
}

export default useMediaCollectionNavigation;
